/*
 *
 * OperationPayToCardDetail
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 19-Oct-2026
 */

import React from 'react'
import PropTypes from 'prop-types'
import PortalTextBlocked from 'Components/PortalTextBlocked'
import formattedMessage from './languageModule'
import './OperationPayToCardDetail.scss'

const OperationPayToCardDetail = ({ info, isLoading }) => {
  const recipient = info?.octRecipient || {}
  const fields = {
    firstName: recipient.firstName || '-',
    lastName: recipient.lastName || '-',
    email: recipient.email || '-',
    phoneNumber: recipient.phoneNumber || '-'
  }

  return (
    <div className='text_field_section'>
      {Object.entries(fields).map(([field, value]) => (
        <PortalTextBlocked
          key={`operation-pay-to-card-recipient-${field}`}
          label={formattedMessage[field]}
          value={value}
          isLoading={isLoading}
          noPadding
        />
      ))}
    </div>
  )
}

OperationPayToCardDetail.propTypes = {
  info: PropTypes.object,
  isLoading: PropTypes.bool
}

OperationPayToCardDetail.defaultProps = {
  info: {},
  isLoading: false
}

export default OperationPayToCardDetail
